/*
 * File: routes.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-30 11:42:50 am
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */
// 基础页面（没有权限控制的）
import baseRouter from './baseRouter';
import noAuthRouter from './noAuthRouter';
import authorityRouter from './authorityRouter';

/* 餐单meta配置项：
  menuKeyPath：一般在详情、编辑、新增页面，表示这个页面在左侧定位到哪个路由；
  insidePageFrom：一般在详情、编辑、新增等内页的外层；做权限控制用，包裹这个页面的内页；
  authKey：一般在详情、编辑、新增等内页，内页的权限，一般带“#”，不带“#”的一般是详情 */

let routes = [
  /// TODO:下面是一个正常页面的路由配置示意，请根据实际项目情况进行配置
  ...baseRouter,
  ...noAuthRouter
];

// 开发环境
// if (process.env.ENV_CONFIG === 'dev') { 
//   routes = [
//     /// TODO:下面是一个正常页面的路由配置示意，请根据实际项目情况进行配置
//     ...baseRouter,
//     // 全部路由，开发坏境不做限制
//     ...authorityRouter
//   ];
// };

export default routes;
